module.exports = __webpack_public_path__ + "media/applicants/right-arrow-7c4e23b9.svg";